import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { UsePanelInsertarCatalogo } from "./UsePanelInsertarCatalogo";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { TextField } from "@fluentui/react";

export interface IPanelInsertarCatalogo extends IOpenPanel{
    esCondicion:boolean
}
export const PanelInsertarCatalogo=(props:IPanelInsertarCatalogo)=>{
    const {request,setRequest,postInsertarCatalogo,loading,disableForm,reset,mensaje,status} = UsePanelInsertarCatalogo(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={postInsertarCatalogo}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [disableForm,request,props.esCondicion]
    );
    return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} onRenderFooter={onRenderFooter}
        textHeader={props.esCondicion?"Agregar Nueva Condición Insegura":"Agregar nuevo  Acto inseguro"} status={status} mensaje={mensaje} loading={loading}>
        <TextField 
         type="text"
         label="Nombre de Catalogo"
         placeholder="Escribir aquí el nombre del catalogo"
         autoComplete="off"
         value={request.nombreCatalogo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombreCatalogo:newValue,esCondicion:props.esCondicion})}
         }}
         />

        </PanelDrawer>
    )

}